import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Button,
  CopyButton,
  Highlight,
  Icon,
  Box as Row,
  toast,
} from '@node-space/ui-components'
import { SidePanelHeaderTemplateTwo } from 'components/SidePanel/SidePanelHeaderTemplates/SidePanelHeaderTemplateTwo'
import { PaymentsResponse } from 'types/payments'
import { paymentLinkBuilder } from 'utils/paymentLinkBuilder'
import { copyToClipboard, getHighlightType, titleCase } from 'utils/utils'

const ICONS_BASE_URL = process.env.ICONS_URL

interface CryptoPaymentsSidePanelHeaderProps {
  cryptoPaymentDetails: PaymentsResponse
}

export const CryptoPaymentsSidePanelHeader = ({
  cryptoPaymentDetails,
}: CryptoPaymentsSidePanelHeaderProps) => {
  const { t } = useTranslation()

  const paymentLink =
    paymentLinkBuilder({
      redirectUrl: cryptoPaymentDetails?.redirectUrl,
      uuid: cryptoPaymentDetails?.uuid,
      paymentType: cryptoPaymentDetails?.type?.toLowerCase(),
    }) || ''

  const headerIconUrls = cryptoPaymentDetails?.paidCurrency?.currency
    ? [`${ICONS_BASE_URL}${cryptoPaymentDetails?.paidCurrency?.currency?.toLowerCase()}.svg`]
    : []

  return (
    <SidePanelHeaderTemplateTwo
      isDividerDisplayed={false}
      heading={{
        iconUrls: headerIconUrls,
        primaryLabel: cryptoPaymentDetails?.displayCurrency
          ? `${cryptoPaymentDetails.displayCurrency.amount ?? ''} ${cryptoPaymentDetails.displayCurrency.currency ?? ''}`.trim()
          : '',
        secondaryLabel: cryptoPaymentDetails?.merchantDisplayName,
      }}
    >
      <Box>
        <Box flexCol className="pl-10" gap={4}>
          <Box flex>
            <p className="text-foreground-prominent text-body-regular">
              {cryptoPaymentDetails?.uuid}
            </p>
            <CopyButton copyText={cryptoPaymentDetails?.uuid} />
          </Box>
          <Box>
            <Highlight type={getHighlightType(cryptoPaymentDetails?.status?.toUpperCase())}>
              {titleCase(cryptoPaymentDetails?.status)}
            </Highlight>
          </Box>
        </Box>
        <Box className="mt-4 ">
          <Row flex className="mt-4 gap-x-8">
            <Button
              variant="ghost"
              noPadding
              iconElement={<Icon name="ArrowSquareOut" />}
              onClick={() => {
                if (paymentLink) {
                  window.open(paymentLink)
                }
              }}
            >
              {t('openPaymentLink')}
            </Button>
            <Button
              variant="ghost"
              noPadding
              iconElement={<Icon name="Copy" />}
              onClick={() => {
                if (paymentLink) {
                  copyToClipboard(paymentLink)
                  toast({ header: `${t('copiedToClipboard')}`, variant: 'success' })
                }
              }}
            >
              {t('copyPaymentLink')}
            </Button>
          </Row>
        </Box>
      </Box>
    </SidePanelHeaderTemplateTwo>
  )
}
